import { useEffect, useState, type JSX } from 'react';
import type { TakiSdk, IaHistoryEvent } from '@taki/sdk';

const ACTION_LABEL: Record<IaHistoryEvent['action'], string> = { create: 'Création', update: 'Modification', archive: 'Archivage', restore: 'Restauration', delete: 'Suppression' };
const SOURCE_LABEL: Record<IaHistoryEvent['source'], string> = { mcp: 'MCP', lia: 'Lia de Taki', automatisation: 'Automatisation' };

/** Provenance des gestes IA, directement sur la fiche que l'on consulte. */
export function AiHistoryPanel({ sdk, family, recordId }: {
  sdk: TakiSdk;
  family: string;
  recordId: string;
}): JSX.Element | null {
  const [events, setEvents] = useState<IaHistoryEvent[]>([]);

  useEffect(() => {
    setEvents([]);
    try {
      return sdk.iaHistory.observe(family, recordId, setEvents, () => setEvents([]));
    } catch {
      return;
    }
  }, [sdk, family, recordId]);

  if (events.length === 0) return null;
  return <section className="mx-5 mt-8 max-w-[42rem] pb-8" aria-label="Historique IA">
    <h3 className="border-b border-border pb-2 text-base font-semibold text-ink-900">Historique IA</h3>
    <div className="pt-2">
      {events.map((event) => <p key={event.id} className="py-2 text-[0.8125rem] leading-5 text-ink-600">
        <span className="font-medium text-ink-900">{ACTION_LABEL[event.action]}</span>
        {' par '}{event.email ?? event.uid}{' via '}{SOURCE_LABEL[event.source]}
        {event.at === null ? '' : `, ${new Intl.DateTimeFormat('fr-LU', { dateStyle: 'medium', timeStyle: 'short' }).format(event.at)}`}
        {event.fields.length === 0 ? '' : ` · ${event.fields.join(', ')}`}
      </p>)}
    </div>
  </section>;
}
